import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a13c68c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OTabelaUsuariosInativos__InformacoesPessoais" }
const _hoisted_2 = { class: "OTabelaUsuariosInativos__NomeEmail" }
const _hoisted_3 = { class: "OTabelaUsuariosInativos__Nome ajustar-textos-longos" }
const _hoisted_4 = { class: "OTabelaUsuariosInativos__Email" }
const _hoisted_5 = { class: "ajustar-textos-longos" }
const _hoisted_6 = { class: "OTabelaUsuarios__GrupoDeBotoes" }

import Column from "primevue/column"
  import DataTable, {
    DataTableFilterMeta,
    DataTableFilterMetaData,
  } from "primevue/datatable"
  import { FilterMatchMode, FilterOperator } from "primevue/api"
  import { AEstadoVazioTabela, MInput } from "@/components/Gerais"

  import { computed, ref } from "vue"
  import { ListarUsuarios } from "@/repositorios/usuarios/usuarios.modelo"
  import Avatar from "primevue/avatar"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"
  import Paginator, { PageState } from "primevue/paginator"
  import { usarFiltragem } from "@/composable/UsarFiltragem"
  import { DadosModal } from "../index.interface"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
import { useI18n } from "vue-i18n"

  interface Props {
    carregandoLista: boolean
    usuariosInativos: ListarUsuarios[]
    primeiraPagina: number
    itensPorPagina: number
    totalDeResultados: number
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaUsuariosInativos',
  props: {
    carregandoLista: { type: Boolean },
    usuariosInativos: null,
    primeiraPagina: null,
    itensPorPagina: null,
    totalDeResultados: null
  },
  emits: ["exibirModalAtivarUsuario", "paginarUsuariosInativos", "filtrarUsuariosInativos", "limparFiltros"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "exibirModalAtivarUsuario", valor: DadosModal)
    (event: "paginarUsuariosInativos", valor: { page: number; rows: number })
    (event: "filtrarUsuariosInativos", valor: Record<string, string>)
    (event: "limparFiltros", valor: Record<string, string>)
  }), expose: any, slots: any, attrs: any }) {

  

  

  const { t } = useI18n()

  const ALTURA_RELATIVA_DA_TABELA = "calc(100vh - 270px)"
  const OPCOES_DE_ITENS_POR_PAGINA = [5, 10, 20, 30]

  const filtros = ref<DataTableFilterMeta | undefined>({
    dataDesativado: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    email: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    codigo: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    nome: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },

    responsaveis: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
  })
  const {
    filtros: filtrosComposable,
    preencherFiltro,
    removerFiltro,
  } = usarFiltragem()

  const { pegarIniciais } = usarFuncoesStrings()

  const desativarLinhaPorStatus = <D extends { ativo?: boolean }>(
    data: D
  ): string | undefined => {
    return data.ativo ? "row-disabled" : undefined
  }

  const estilizarLabelAvatar = (label: string, avatar: string) => {
    if (avatar) {
      return undefined
    } else {
      return pegarIniciais(label)
    }
  }

  const exibirModal = (id: string, nome: string) => {
    const informacoesModal: DadosModal = {
      id,
      nome,
      acao: "ativar",
      legenda: t("umUsuarioAtivadoNaoPoderaMaisSerUtilizado"),
      modalEstaAberto: true
    }
    emitir("exibirModalAtivarUsuario", informacoesModal)
  }

  const permissionamento = computed(() => {
    const permissao = usarPermissionamento("Usuarios")
    return {
      ativar: permissao.verificarPermissao("ativar")
    }
  })

  const onPaginarUsuariosInativos = ({ page, rows }: PageState) => {
    emitir("paginarUsuariosInativos", { page, rows })
  }

  const aplicarFiltros = async (
    dadosDoPreenchimentoDoFiltro: Record<string, any>,
    nomeDaColunaNaAPI: string
  ) => {
    const { matchMode, value } = (
      dadosDoPreenchimentoDoFiltro as DataTableFilterMeta
    ).constraints[0]
    preencherFiltro(nomeDaColunaNaAPI, matchMode, value)
    emitir("filtrarUsuariosInativos", filtrosComposable.value)
  }

  const limparFiltros = async (nome, filterCallback) => {
    removerFiltro(nome)
    filterCallback()
    emitir("limparFiltros", filtrosComposable.value)
  }

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    filters: filtros.value,
    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((filtros).value = $event)),
    class: "OTabelaUsuarios p-datatable-sm",
    "data-key": "id",
    "data-testid": "OTabelaUsuariosInativos",
    "filter-display": "menu",
    "global-filters-fields": ['nome', 'id', 'responsaveis'],
    loading: __props.carregandoLista,
    "responsive-layout": "scroll",
    "row-class": desativarLinhaPorStatus,
    rows: 5,
    "scroll-height": ALTURA_RELATIVA_DA_TABELA,
    scrollable: "",
    "striped-rows": "",
    value: __props.usuariosInativos
  }, _createSlots({
    loading: _withCtx(() => [
      _createVNode(_component_Skeleton, {
        height: "100%",
        width: "100%"
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Paginator), {
        onPage: onPaginarUsuariosInativos,
        "current-page-report-template": "{first}-{last} de {totalRecords}",
        "data-testid": "OTabelaUsuariosInativos__Paginator",
        first: __props.primeiraPagina,
        rows: __props.itensPorPagina,
        "rows-per-page-options": OPCOES_DE_ITENS_POR_PAGINA,
        template: "FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown",
        "total-records": __props.totalDeResultados
      }, null, 8, ["first", "rows", "total-records"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        class: "OTabelaUsuarios__Column",
        field: "nome",
        header: _unref(t)('nome'),
        "show-add-button": false,
        "show-filter-operator": false,
        sortable: ""
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Avatar), {
              class: "OTabelaUsuariosInativos__Avatar",
              image: data.fotoDeAvatar,
              label: estilizarLabelAvatar(data.nome, data.fotoDeAvatar),
              shape: "circle"
            }, null, 8, ["image", "label"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(data.nome), 1),
              _createElementVNode("small", _hoisted_4, _toDisplayString(data.email), 1)
            ])
          ])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_unref(MInput), {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            nome: "filtro-nome-do-usuario",
            placeholder: _unref(t)('pesquisarPorNomeDoUsuario'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        filterclear: _withCtx(({ field, filterCallback }) => [
          _createVNode(_component_PButton, {
            onClick: ($event: any) => (limparFiltros(field, filterCallback))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        filterapply: _withCtx(({ filterModel, field }) => [
          _createVNode(_component_PButton, {
            onClick: ($event: any) => (aplicarFiltros(filterModel, field))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OTabelaUsuarios__Column",
        field: "codigo",
        header: _unref(t)('codigo'),
        "show-add-button": false,
        "show-filter-operator": false
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(data.codigo), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_unref(MInput), {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            nome: "filtro-codigo",
            placeholder: _unref(t)('pesquisarPorCodigo'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        filterclear: _withCtx(({ field, filterCallback }) => [
          _createVNode(_component_PButton, {
            onClick: ($event: any) => (limparFiltros(field, filterCallback))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        filterapply: _withCtx(({ filterModel, field }) => [
          _createVNode(_component_PButton, {
            onClick: ($event: any) => (aplicarFiltros(filterModel, field))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OTabelaUsuarios__Column OTabelaUsuarios__Actions",
        field: "acoes",
        header: "",
        "show-add-button": false,
        "show-filter-operator": false,
        style: {"flex":"0"}
      }, {
        body: _withCtx(({ data: usuario }) => [
          _createElementVNode("div", _hoisted_6, [
            (_unref(permissionamento).ativar)
              ? _withDirectives((_openBlock(), _createBlock(_component_PButton, {
                  key: 0,
                  onClick: ($event: any) => (exibirModal(usuario.id, usuario.nome)),
                  class: "OTabelaUsuarios__IButton p-button-rounded",
                  "data-testid": "OTabelaUsuarios__AtivarUsuario",
                  icon: "pi pi-user-plus"
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('ativar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (!__props.carregandoLista)
      ? {
          name: "empty",
          fn: _withCtx(() => [
            _createVNode(_unref(AEstadoVazioTabela))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["filters", "loading", "value"]))
}
}

})